import { Entry } from '../Entry'

export function Entry20220517() {
  return (
    <Entry title="17/05/2022 - v3.0.7">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12604/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
